

























import Vue from 'vue'
import ProductMenuListMobile from '@/common/components/globalHeader/ProductMenuListMobile.vue'
import { ProductCategory } from '@/model/productCategory'

export default Vue.extend({
  components: {
    ProductMenuListMobile
  },
  props: {
    productCategories: {
      type: Array as () => ProductCategory[],
      default: () => []
    }
  },
  data(): {
    isProductMenuOpen: boolean
  } {
    return {
      isProductMenuOpen: false
    }
  }
})
